// Default site content. Admins override any field from /admin (stored in MongoDB).
import ARTICLES from "../seo/articles.json";

export const STATUS_OPTIONS = ["available", "planned", "pending"];
export const VISIBILITY_OPTIONS = ["published", "review"];

export const DEFAULT_CONTENT = {
  company: {
    name: "BOSS EMPIRE PRIVATE LIMITED",
    shortName: "BOSS EMPIRE",
    tagline: "Innovation • Business • Technology",
    industry: "Technology, Artificial Intelligence, Digital Platforms, Business & Innovation",
    summary:
      "BOSS EMPIRE PRIVATE LIMITED is the parent company behind a family of digital platforms and technology ventures — spanning social media, digital commerce and artificial intelligence.",
  },
  hero: {
    line1: "BOSS EMPIRE",
    line2: "PRIVATE LIMITED",
    headline: "Building the Future of Digital Innovation",
  },
  about: {
    statement:
      "We build digital platforms where people connect, trade and work smarter — and we hold every venture to one standard: technology that earns its place in everyday life.",
    mission:
      "To design and operate digital platforms and technology products that are useful, trustworthy and built for the scale of modern India and beyond.",
    vision:
      "A connected ecosystem of social, commerce and intelligence platforms, each strong on its own and stronger together.",
    pillars: [
      { title: "Innovation", text: "We start from problems people actually have and build new products around them." },
      { title: "Business", text: "Every venture is built to be sustainable, accountable and commercially sound." },
      { title: "Technology", text: "Modern engineering, AI and thoughtful design sit at the core of everything we ship." },
      { title: "Long-term thinking", text: "We invest in platforms meant to grow with their communities over years, not quarters." },
    ],
  },
  platforms: {
    indril: {
      name: "IND RIL",
      category: "Next-generation Indian social media platform",
      description:
        "IND RIL is a social platform designed for how India creates and connects — short videos, stories, conversations, creator tools and live audio in one place.",
      url: "https://indril.in",
      appStoreUrl: "https://apps.apple.com/in/app/ind-ril/id6785839574",
      playStoreUrl: "https://play.google.com/store/apps/details?id=app.emergent.indiareels1f783207d",
      features: [
        { name: "Reels", text: "Short-form vertical video for discovery and expression.", status: "available" },
        { name: "Stories", text: "Moments that disappear, shared with your circle.", status: "available" },
        { name: "Feed", text: "Posts from people and creators you follow.", status: "available" },
        { name: "Messaging", text: "Private one-to-one and group conversations.", status: "available" },
        { name: "Creator Tools", text: "Tools that help creators publish and grow.", status: "available" },
        { name: "Live Audio", text: "Real-time audio rooms for conversations at scale.", status: "pending" },
      ],
    },
    usb: {
      name: "URGENT SELL & BUY",
      category: "Digital marketplace",
      description:
        "Urgent Sell & Buy connects buyers and sellers through a fast, simple marketplace — list what you have, find what you need and close the deal.",
      url: "",
      features: [
        { name: "Product listings", text: "Create a listing with photos, price and details in minutes.", status: "pending" },
        { name: "Search & discovery", text: "Find items by keyword, category and location.", status: "pending" },
        { name: "Buying experience", text: "Browse, compare and contact sellers directly.", status: "pending" },
        { name: "Selling experience", text: "Reach interested buyers quickly when time matters.", status: "pending" },
      ],
    },
    aios: {
      name: "BOSS AI OS",
      category: "AI-powered operating system & business intelligence platform",
      description:
        "BOSS AI OS brings artificial intelligence into the daily operation of a business — an intelligent interface for commands, agents, automated workflows and decision dashboards.",
      url: "",
      features: [
        { name: "AI command interface", text: "Ask, instruct and navigate with natural language.", status: "pending" },
        { name: "Voice assistant", text: "Hands-free interaction through voice.", status: "pending" },
        { name: "AI agents", text: "Task-focused agents that work on your behalf.", status: "pending" },
        { name: "Workflow automation", text: "Connect steps across tools and automate repetitive work.", status: "pending" },
        { name: "Business dashboards", text: "Live views of the metrics that run your business.", status: "pending" },
      ],
    },
  },
  founder: {
    name: "Zahir Patel",
    alias: "Boss Patel",
    title: "Founder & CEO — BOSS EMPIRE PRIVATE LIMITED",
    intro:
      "Zahir Patel, known as Boss Patel, is the Founder and CEO of BOSS EMPIRE PRIVATE LIMITED. An entrepreneur focused on technology and innovation, he leads the company's portfolio of digital ventures — IND RIL, Urgent Sell & Buy and BOSS AI OS — with a long-term vision of building platforms that people rely on every day.",
    philosophy: "Build with vision. Lead with discipline. Create for the long term.",
    socials: [],
    focus: [
      { title: "Entrepreneurship", text: "Turning bold ideas into accountable, working businesses." },
      { title: "Technology", text: "Using modern engineering and AI as the foundation of every product." },
      { title: "Innovation", text: "Challenging how social, commerce and business software should work." },
      { title: "Long-term vision", text: "Building an ecosystem designed to compound over time." },
    ],
  },
  vision: {
    statement:
      "Our vision is an ecosystem where social connection, digital commerce and artificial intelligence reinforce one another — giving people and businesses better tools to create, trade and grow.",
    themes: [
      { horizon: "Now", title: "Strengthen the core platforms", text: "Focus on product quality, reliability and user trust across IND RIL, Urgent Sell & Buy and BOSS AI OS." },
      { horizon: "Next", title: "Connect the ecosystem", text: "Explore ways for the platforms to share identity, insight and intelligence responsibly." },
      { horizon: "Future", title: "AI at the centre", text: "Make intelligent assistance a natural part of how people and businesses use our products." },
    ],
  },
  news: {
    press: [
      {
        source: "Mid-day",
        section: "Buzz",
        title: "Zahir Patel: The Low-Key Powerhouse in African Mining",
        date: "2025-05-14",
        summary: "Profile describing Zahir Patel as a Gujarati entrepreneur with business interests in Africa, including gold, diamond and copper mining.",
        url: "https://www.mid-day.com/buzz/article/zahir-patel-the-low-key-powerhouse-in-african-mining-5938",
        visibility: "published",
        note: "",
      },
      {
        source: "Telangana Today",
        section: "Advertisement",
        title: "Entrepreneur and producer Zahir Patel talks about starting an NGO",
        date: "2023-02-22",
        summary: "Piece on Zahir Patel's intention to start an NGO supporting education for children who cannot afford it.",
        url: "https://telanganatoday.com/entrepreneur-and-producer-zahir-patel-talks-about-starting-an-ngo",
        visibility: "published",
        note: "",
      },
      {
        source: "INFOSAURS",
        section: "Entrepreneurs",
        title: "Zahir Patel Wiki, Age, Biography, Height, Girlfriend, Family, Images, And More",
        date: "2023-02-21",
        summary: "Biography page on a PR-wire site.",
        url: "https://infosaurs.com/entrepreneurs/zahir-patel/1679",
        visibility: "review",
        note: "Held for owner review: contains unverified net-worth and wealth-ranking claims; real title differs from the one supplied.",
      },
      {
        source: "Winsaa Wiki",
        section: "Wiki",
        title: "Zahir Patel",
        date: "",
        summary: "Open wiki profile.",
        url: "https://winsaa.org/wiki/Zahir_Patel",
        visibility: "review",
        note: "Held for owner review: open, user-editable wiki that includes a 'Controversies and Speculations' section.",
      },
    ],
    articles: ARTICLES,
    items: [
      {
        title: "IND RIL apps listed on the App Store and Google Play",
        date: "",
        summary:
          "IND RIL, the social media platform from Boss Empire Private Limited, is listed on the Apple App Store and Google Play, as linked from its official website indril.in.",
        url: "https://indril.in",
      },
    ],
  },
  contact: {
    email: "bossempirepvtltd@gmail.com",
    phone: "",
    address: "",
    cin: "",
    hours: "",
  },
  legal: {
    lastUpdated: "2026-11-03",
    privacy:
      "This Privacy Policy explains how BOSS EMPIRE PRIVATE LIMITED (\"we\", \"us\") handles information collected through this website.\n\nInformation we collect: When you submit the contact form we collect your name, email address, optional company name, subject and message, together with your IP address for spam and abuse prevention.\n\nHow we use it: Solely to respond to your enquiry, maintain records of correspondence and protect this website from abuse. We do not sell personal information.\n\nRetention: Contact enquiries are retained only as long as needed for the purposes above, after which they are deleted.\n\nCookies: This website does not use advertising or tracking cookies. A strictly necessary cookie is used only for the administrator area.\n\nYour rights: You may request access to, correction of or deletion of your personal information by contacting us using the details on the Contact page.\n\nThis document is a template and must be reviewed by qualified legal counsel before publication.",
    terms:
      "By using this website you agree to these Terms.\n\nContent: Information on this website is provided for general information about BOSS EMPIRE PRIVATE LIMITED and its platforms. Product features and availability may change. Interface previews shown on this website are illustrative.\n\nIntellectual property: The BOSS EMPIRE name, logo, platform names and website content are the property of BOSS EMPIRE PRIVATE LIMITED unless stated otherwise.\n\nThird-party links: Links to external websites, including platform websites, are provided for convenience and are governed by their own terms.\n\nLimitation of liability: The website is provided \"as is\" without warranties of any kind to the extent permitted by law.\n\nGoverning law: These Terms are governed by the laws of India.\n\nThis document is a template and must be reviewed by qualified legal counsel before publication.",
  },
};

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

export function mergeDeep(base, over) {
  if (!isObj(over)) return base;
  const out = { ...base };
  Object.keys(over).forEach((k) => {
    if (isObj(base?.[k]) && isObj(over[k])) out[k] = mergeDeep(base[k], over[k]);
    else if (over[k] !== undefined && over[k] !== null) out[k] = over[k];
  });
  return out;
}
